/**
 * @returns true if the current device is a smartphone. Tablets and desktop will return false.
 */
export function isMobile() {
  return window.fandomHost?.device === "smartphone";
}
